export const selectFSTextDataForOrder = state =>
  state.fashionstore.fsTextDataForOrder;

export const selectFSNewOrderStatus = state =>
  state.fashionstore.fsNewOrderStatus;

export const selectFSOwnFilesForNewOrder = state =>
  state.fashionstore.fsOwnFilesForNewOrder;

export const selectFSOrderImages = state => state.fashionstore.fsOrderImages;

export const selectFSOrderList = state => state.fashionstore.fsOrderList;

export const selectFSIsLoading = state => state.fashionstore.fsIsLoading;

export const selectFSErrorMessage = state =>
  state.fashionstore.fsResponseErrorMessage;

export const selectShopifyApp = state =>
  state.fashionstore.integrations.shopify.shopifyApp;

export const selectShopifyShopName = state =>
  state.fashionstore.integrations.shopify.shopifyShopName;
